/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Last_NameInputs */



/**
* | output |
* | --- |
* | "Last name" |
*
* @param {Settings_Last_NameInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_last_name = /** @type {((inputs?: Settings_Last_NameInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Last_NameInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Achternaam")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom de famille")
	return /** @type {LocalizedString} */ ("Last name")
});